var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPic01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 255,
    viewBox: "0 0 207 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_459)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18_459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.485 38.4851C135.369 50.3906 107.389 24.8354 103.619 21.0644C103.619 21.0644 103.543 20.6876 103.397 20.8395C103.251 20.6876 103.175 21.0644 103.175 21.0644C99.4021 24.8354 71.4254 50.3906 16.3092 38.4851C16.3092 38.4851 7.84735 137.439 39.9743 177.808C74.2876 220.924 103.251 233.96 103.397 233.851C103.543 233.963 132.753 221.173 166.82 177.808C198.691 137.239 190.485 38.4851 190.485 38.4851Z",
    fill: "#E3E5E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M93.7227 150.005L96.9808 118.673C93.3817 116.51 90.9671 112.58 90.9671 108.083C90.9671 101.252 96.518 95.7128 103.363 95.7128V20.8186C103.235 20.7457 103.168 21.0647 103.168 21.0647C99.3954 24.8357 71.4187 50.391 16.3025 38.4855C16.3025 38.4855 7.84063 137.44 39.9676 177.809C73.7328 220.235 102.312 233.535 103.36 233.845V150.008H93.7197L93.7227 150.005Z",
    fill: "url(#paint0_linear_18_459)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M166.816 177.805C198.687 137.236 190.481 38.482 190.481 38.482C135.368 50.3906 107.388 24.8354 103.619 21.0644C103.619 21.0644 103.543 20.6876 103.396 20.8395C103.387 20.8274 103.375 20.8274 103.366 20.8213V95.7155C110.211 95.7155 115.762 101.255 115.762 108.086C115.762 112.623 113.308 116.579 109.657 118.73L112.318 150.007H103.366V233.844C103.384 233.851 103.393 233.851 103.396 233.851C103.543 233.963 132.753 221.173 166.819 177.808L166.816 177.805Z",
    fill: "url(#paint1_linear_18_459)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18_459",
    x: 10.6019,
    y: 16.1034,
    width: 185.531,
    height: 222.448,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.35
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.866667 0 0 0 0 0.886275 0 0 0 0.92 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18_459"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18_459",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_459",
    x1: 15.3007,
    y1: 127.324,
    x2: 103.366,
    y2: 127.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_459",
    x1: 103.366,
    y1: 127.324,
    x2: 218.495,
    y2: 127.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E1FB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 183,
    height: 220,
    fill: "white",
    transform: "translate(12 17.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic01);
export default __webpack_public_path__ + "static/media/pic_01.2463dadaaf8cafaae10e695196e72d06.svg";
export { ForwardRef as ReactComponent };